import React from 'react'; 
import './TaxiSlider.css';

import { Taxi, Heading } from '../../../components';
import { taxis } from '../../../constants';

// import Swiper core and required modules 
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
 
// Import Swiper styles  
import 'swiper/css';



const TaxiSlider = () => {

  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Taxis'} subTitle={'Our Taxi Fleet'} />

      <div className='taxi-slider'>
        <Swiper 
          // install Swiper modules
          modules={[Autoplay]}
          spaceBetween={10} // Space between slides
          loop={true} // Enable infinite loop
          autoplay={{ delay: 3500, disableOnInteraction: false }} // Auto-play settings
          breakpoints= {{
            0:{ 
              slidesPerView: 1, // Show 1 slide on small screens
            },
            768:{
              slidesPerView: 2, // Show 2 slides on tablets
            },
            991:{
              slidesPerView: 3, // Show 3 slides on larger screens
            }
          }}
        >
          {// Mapping through the Taxis array to create slides
            taxis.map((taxi, index) => { 
              return (
                <SwiperSlide key={index}> 

                  <Taxi taxi={taxi} /> {/* Rendering Taxi component */}

                </SwiperSlide>
              )
            })
          }

        </Swiper>
      </div>

    </section>

  );
}

export default TaxiSlider;